import { formatCurrency, pn, Skeleton, Stack } from "@compass/core";
import { HomeMatchDashboardRow } from "generated/openApi";
import PieChart, { Series, Tooltip } from "devextreme-react/pie-chart";
import Chart, { Legend, Series as ChartSeries, Tooltip as ChartTooltip, ValueAxis } from "devextreme-react/chart";
import { DashboardChartView } from "../types";
import { DASHBOARD_DISTRIBUTION_COLORS, getDashboardDistributionColor } from "../types";

export const DashboardPieChart = (props: {
  rows: HomeMatchDashboardRow[] | undefined;
  loading: boolean;
  chartView: DashboardChartView;
}) => {
  return props.loading ? (
    <Stack direction="row" spacing="lg">
      <Skeleton variant="rounded" width={"70%"} height={400} />
      <Skeleton variant="rounded" width={"30%"} height={200} />
    </Stack>
  ) : (
    <Stack width="100%" height="100%" direction="column" spacing="lg">
      {(props.chartView === 'pie' || props.chartView === 'fullPie') ? <PieChart
        dataSource={props.rows}
        height="100%"
        type={props.chartView === 'fullPie' ? 'pie' : 'doughnut'}
        onPointHoverChanged={(pointInfo: any) => {
          if (pointInfo.target.isHovered()) {
            pointInfo.target.showTooltip();
          } else {
            pointInfo.target.hideTooltip();
          }
        }}
        palette={DASHBOARD_DISTRIBUTION_COLORS}
      >
        <Series
          argumentField={pn<HomeMatchDashboardRow>("label")}
          valueField={pn<HomeMatchDashboardRow>("amount")}
        ></Series>
        <Tooltip
          enabled={false}
          customizeTooltip={(arg) => {
            return {
              text: `${arg.argumentText}: <b>${formatCurrency(Number(arg.valueText))}</b>`,
            };
          }}
        />
      </PieChart> : <Chart dataSource={props.rows} height="100%" rotated={props.chartView === 'horizontalBar'} palette={DASHBOARD_DISTRIBUTION_COLORS} customizePoint={(args: any) => ({ color: getDashboardDistributionColor(args.index) })}>
        <ChartSeries type="bar" argumentField={pn<HomeMatchDashboardRow>("label")} valueField={pn<HomeMatchDashboardRow>("amount")} />
        <ValueAxis /><Legend visible={false} /><ChartTooltip enabled customizeTooltip={arg => ({ text: `${arg.argumentText}: ${formatCurrency(Number(arg.valueText))}` })} />
      </Chart>}
    </Stack>
  );
};
